import styled from 'styled-components';
import {colors} from "../ui/globalColors";

export const StyledChecklistDropdown = styled.div`
  position: absolute;
  background: white;
  box-shadow: 0px 5px 30px rgba(89, 102, 137, 0.3);
  border-radius: 11px;
  display: grid;
  z-index: 999;
  top: 100%;
  width: 100%;
  overflow: auto;
  overflow-y: hidden;
  height: 30vh;
    .list-row {
      padding: 15px 10px;
      border-bottom: 1px solid #A8C0FF;
      
      .checklist-dropbox {
        margin-left: 10px;
      }
    }
  .list-row-checked {
    padding: 15px 10px;
    border-bottom: 1px solid #A8C0FF;
    background-color: ${colors.additionalColors.lightGray};

    .checklist-dropbox {
      margin-left: 10px;
    }
  }
  .list-row:hover{
    background-color: ${colors.additionalColors.lightGray};
  }

    label {
      margin-bottom: 0px;
    }
`